import { styled } from 'shared/Houston';

interface IProps {
  width?: string;
  height?: string;
}

export const Spinner = styled.div<IProps>`
  width: ${({ width }) => width || '56'}px;
  height: ${({ height }) => height || '56'}px;
  border-radius: ${({ theme }) => theme.border.radius.circular};
  background: ${({
    theme
  }) => `radial-gradient(farthest-side, ${theme.brandColor.primary.pure} 94%, #0000) top/9px 9px no-repeat,
    conic-gradient(#0000 30%, ${theme.brandColor.primary.pure})`};
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 9px), #000 0);
  animation: spinner-c7wet2 1s infinite linear;

  @keyframes spinner-c7wet2 {
    100% {
      transform: rotate(1turn);
    }
  }
`;
